module.exports = __webpack_public_path__ + "static/img/machinery1.4794988.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/machinery1.png
// module id = UvGs
// module chunks = 1